module.exports = __webpack_public_path__ + "static/media/move_icon.3580e1b6.svg";